import * as React from "react";
import { forwardRef } from "react";
const SvgDownArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.29402 11.7071C7.6845 12.0976 8.31863 12.0976 8.7091 11.7071L13.7071 6.70821C14.0976 6.31767 14.0976 5.68344 13.7071 5.2929C13.3167 4.90237 12.6825 4.90237 12.2921 5.2929L8 9.5857L3.70793 5.29603C3.31745 4.90549 2.68333 4.90549 2.29285 5.29603C1.90238 5.68657 1.90238 6.3208 2.29285 6.71134L7.2909 11.7102L7.29402 11.7071Z", fill: "#222222" }));
const ForwardRef = forwardRef(SvgDownArrow);
export default ForwardRef;
